import { collection, getDocs } from 'firebase/firestore';
import { SpecialtyRepository } from '../../../domain/contracts/repositories';
import { Specialty } from '../../../domain/entities';
import db from '../../../setup/firebase/firebase';
import { FirebaseSpecialty } from '../entities';
import { SpecialtyMapper } from '../mappers/specialty.mapper';

export class FirebaseSpecialtyRepository implements SpecialtyRepository {
  private readonly COLLECTION_PATH = 'specialties';

  async findAll(): Promise<Specialty[]> {
    const querySnapshot = await getDocs(collection(db, this.COLLECTION_PATH));
    const specialties = querySnapshot.docs.map((doc) => {
      const specialty = doc.data() as FirebaseSpecialty;
      specialty.id = doc.id;
      return specialty;
    });
    return specialties.map((specialty) => SpecialtyMapper.toDomain(specialty));
  }
}
